import state from './building.state'
import mutations from './building.mutations'
import actions from './building.actions'

export default {
  state,
  mutations,
  actions
}
